import React from "react";
import Header from "../../components/common/Header";
import Sidebar from "../../components/common/Sidebar";
import Footer from "../../components/common/Footer";
import SubscriptionsMain from "../../components/settings/subscriptions/SubscriptionsMain";
import { RODEO_PAGE_NAME } from "../../_config";

const SubscriptionsContainer: React.FC = () => {
  return (
    <>
      <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.SETTINGS_SUBSCRIPTIONS} showSettingsSidebar={true} />
      <SubscriptionsMain />
      <Footer variant="dashboard" />
    </>
  );
};

export default SubscriptionsContainer;